angular.module("siter.io").controller "NewImageCtrl", ["$scope","$rootScope", "$modalInstance", "Widget", "Translit", "FileUploader", "Restangular", "$state", "$cookies", "$q", "$filter", ($scope, $rootScope, $modalInstance, Widget, Translit, FileUploader, Restangular, $state, $cookies, $q, $filter) ->

  bulletsTag = $filter('translate')('widget.tags.bullets')

  Restangular.all('/images/tags').getList().then (tags) ->
    if tags.indexOf(bulletsTag) is -1
      tags.push bulletsTag
    $scope.imagesTags = tags

  $scope.loadImagesTags = (query) ->
    deferred = $q.defer()
    deferred.resolve $filter('filter')($scope.imagesTags, query)
    deferred.promise

  $scope.new_image = {disabled: true}

  # Close

  $scope.landing = {}
  $scope.cancel = ->
    $modalInstance.dismiss "cancel"


  # Preview web uploader

  $scope.imageUploader = new FileUploader(
    url: ""
    autoUpload: false
    method: "PUT"
    alias: "image_attributes[source]"
    headers : {
      'X-AUTH-TOKEN': Restangular.defaultHeaders['X-AUTH-TOKEN']
    }
  )

  $scope.imageUploader.onAfterAddingFile = (item) ->
    types = ["image/jpeg", "image/png", "image/svg+xml"]
    if item.file.type not in types
      alert("The file must be png or jpg")
      return false
  $scope.imageUploader.onSuccessItem = (fileItem, response, status, headers) ->
    $scope.imageUploader.clearQueue()
    $scope.new_image.image_attributes = response.image_attributes
    return

  $scope.imageUploader.onErrorItem = (fileItem, response, status, headers) ->
    return

  setUploadUrls = (imageId) ->
    $scope.imageUploader.queue.forEach (item) ->
      item.url = Restangular.configuration.baseUrl+"/images/#{imageId}"
  # Creating site

  $scope.creating = false

  $scope.createImage = (image, newTemplateForm) ->
    return false if newTemplateForm.$invalid
    $scope.creating = true

    image = angular.copy image

    image.tag = image.tag[0].text

    Widget.createImage(image).then (new_image) ->
      $scope.new_image = new_image
      $scope.creating = false
      setUploadUrls $scope.new_image.id
      $scope.imageUploader.uploadAll()
      $rootScope.$broadcast "image:created", $scope.new_image
      $scope.close()
    , (errors) ->
      $scope.errors = errors.data.errors
      $scope.creating = false


  # Close

  $scope.close = ->
    $modalInstance.dismiss "close"
]



// WEBPACK FOOTER //
// ./src/app/dashboard/images/new_image.controller.coffee